<template>
    <div class="resol-tree">
        <template v-if="items == null || items.length === 0">
            <div class="div-table-row dtr-no-data">
                <div class="cfl-placeholder">{{ $t("К_сожалению,_по_Вашему_запросу_ничего_не_найдено") }}</div>
            </div>
        </template>
        <template v-else>
            <DepartmentItem
                v-for="item in items"
                :key="item.id"
                :item="item"
                :open-all="openAll"
                :active-id="activeId"
                :on-item-click="onTreeItemClick"
                :on-item-dbl-click="onTreeItemDblClick"
                :on-invoke-action="onInvokeAction"
                :query="query"
                :on-item-transfer="onTreeItemTransfer"
            />
        </template>
    </div>
</template>

<script>
import DepartmentItem from '@/components/ems/DepartmentItem.vue'

export default {
    name: "DepartmentsTreeView",
    components: {
        DepartmentItem,
    },
    props: {
        items: Array,
        query: String,
        openAll: Boolean
    },
    data() {
        return {
            activeId: null,
            activeItem: null,
        }
    },
    methods: {
        onTreeItemClick(item) {
            if (this.activeId !== item.id) {
                this.activeId = item.id;
                this.activeItem = item;
                this.$emit('on-selected-change', item);
            }

            this.$emit('on-item-click', item);
        },
        onTreeItemDblClick(item) {
            this.$emit('on-item-dbl-click', item);
        },
        onInvokeAction(action, item) {
            this.$emit('on-invoke-action', action, item);
        },
        onTreeItemTransfer(fromItem, toItem){
            this.$emit('on-tree-item-transfer', fromItem, toItem);
        }
    },
    watch: {
        items() {
            this.activeId = null;
            this.activeItem = null;
            this.$emit('on-selected-change', null);
        }
    }
}
</script>